import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "accident-plan-report" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-camera" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Photos")
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-microphone" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Recordings")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-chat-line-round" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Details")
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportSummaryComp = _resolveComponent("ReportSummaryComp")
  const _component_ReportPhotos = _resolveComponent("ReportPhotos")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_ReportRecordingsComp = _resolveComponent("ReportRecordingsComp")
  const _component_ReportQuestionsComp = _resolveComponent("ReportQuestionsComp")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ReportSummaryComp, {
      report: _ctx.report,
      records: _ctx.records ?? []
    }, null, 8, ["report", "records"]),
    (_ctx.isPrinting === false)
      ? (_openBlock(), _createBlock(_component_el_tabs, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              class: "full-height",
              lazy: true
            }, {
              label: _withCtx(() => [
                _hoisted_2,
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ReportPhotos, {
                  report: _ctx.report,
                  records: _ctx.records ?? []
                }, null, 8, ["report", "records"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              class: "full-height",
              lazy: true
            }, {
              label: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ReportRecordingsComp, {
                  report: _ctx.report,
                  records: _ctx.records ?? []
                }, null, 8, ["report", "records"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              class: "full-height",
              lazy: true
            }, {
              label: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ReportQuestionsComp, {
                  report: _ctx.report,
                  records: _ctx.records ?? [],
                  isPrinting: false
                }, null, 8, ["report", "records"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode(_component_ReportQuestionsComp, {
            report: _ctx.report,
            records: _ctx.records ?? [],
            isPrinting: _ctx.isPrinting
          }, null, 8, ["report", "records", "isPrinting"])
        ]))
  ]))
}